import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { login } from "actions/mypage/login";
import { showAlert } from "actions/common/alert";
import Login from "components/Mypage/Login";

const mapStateToProps = ({ mypageLogin: { token, error } }) => ({
  token,
  error
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      login,
      push,
      showAlert
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/containers/Mypage/Login/index.js